import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/_authenticated/workspaces/$workspaceId/journeys/geofences/$geofenceId')({
  beforeLoad: ({ params }) => {
    throw redirect({
      to: '/workspaces/$workspaceId/geofences/$geofenceId',
      params: {
        workspaceId: params.workspaceId,
        geofenceId: params.geofenceId,
      },
      replace: true,
    });
  },
});
